import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import Sift from "@/components/sift/Sift";
export default {
  name: "ServeSearchView",
  components: {
    Sift: Sift
  },
  props: ["queryType"],
  data: function data() {
    return {
      isShow: false,
      loading: false,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      siftData: [],
      list: [],
      downloadUrl: ""
    };
  },
  created: function created() {},
  computed: _objectSpread({}, mapState(["userToken"])),
  mounted: function mounted() {// this.fetchSiftData();
  },
  methods: {
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true;
      this.$http.post("serveCount/queryTitle").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == "0") {
          _this.siftData = data.resData.siftData;
          _this.siftData[_this.siftData.length - 1].placeholder = "可输入姓名、学号、工号搜索";
          _this.loading = false;
        } else {
          _this.loading = false;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;

      this.loading = true;
      var obj = {};

      if (this.siftData.length) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;

      if (this.queryType) {
        obj.queryType = this.queryType;
      }

      this.$http.post("serveCount/query", JSON.stringify(obj), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == "0") {
          _this2.list = data.resData.list;
          _this2.total = data.resData.total;
          _this2.loading = false;
        } else {
          _this2.loading = false;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    download: function download() {
      var _this3 = this;

      var obj = {};

      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }

      if (this.queryType) {
        obj.queryType = this.queryType;
      }

      obj.token = this.userToken;
      this.downloadUrl = this.$pramsUrl.getUrl(obj, "serveCount/query/export");
      this.$nextTick(function () {
        _this3.$refs.downloadExcel.click();
      });
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showView: function showView() {
      this.isShow = true;

      if (!this.siftData.length) {
        this.fetchSiftData();
      }
    }
  }
};